/**
 * NOTE:
 * - R6 April [established:新設]
 */

import { t } from "i18next"
import { Version, getCurrentVersion } from "@project/shared"
import { Moment } from "moment"
import { FormFieldsProp } from "../../../../molecules/FormFields/types"
import { ChildDevelopmentSupportRevenueCondition1, ServiceType } from "./types"

type Params = {
  name: string
  service: number
  condition: number
}

/**
 * Version management: Facility Status Form
 * @param {Moment} date
 * @param {Params} params
 * @return {FormFieldsProp|null}
 */
export function getCoreFunctionEnhancementAddition(
  date: Moment,
  params: Params
) {
  /**
   * NOTE
   * ja: 児童発達支援センター でのみ表示
   * en: Show only for "Child Development Support Center"
   */
  if (
    params.service !== ServiceType.CHILD_DEVELOPMENT_SUPPORT ||
    params.condition !==
      ChildDevelopmentSupportRevenueCondition1.CHILD_DEVELOPMENT_SUPPORT_CENTER
  ) {
    return null
  }

  const { version } = getCurrentVersion(date.format("YYYY-MM-DD"))

  switch (version) {
    case Version.BASELINE:
      return null
    default:
      return r6April(params.name)
  }
}

/**
 * --------------------------------
 * @version R6_APRIL
 * --------------------------------
 */

function r6April(name: string): FormFieldsProp {
  return {
    // TODO: translate
    fieldLabel: "中核機能強化加算",
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: [
              {
                label: t("No"),
                value: "0",
              },
              {
                label: t("I"),
                value: "1",
              },
              {
                label: t("II"),
                value: "2",
              },
              {
                label: t("III"),
                value: "3",
              },
            ],
          },
        },
      },
    ],
  }
}

/**
 * --------------------------------
 * @version BASELINE
 *
 * NONE
 * --------------------------------
 */
